const ExcelJS = require('exceljs');

export const consolidateMovementsReport = async (data) => {

    let movements = []
    data.map(column => {
        movements.push(column)
        return column
    })

    const workbook = new ExcelJS.Workbook();
    workbook.addWorksheet("sheet1");
    const worksheet = workbook.getWorksheet("sheet1");

    const cabeceras = [
        'Fecha',
        'Tipo',
        'Concepto',
        'Valor',
        'Saldo',
    ];
    worksheet.views = [
        { state: 'worksheet', zoomScale: 127, }
    ];

    const fuenteHoja = 'Calibri';

    const cabeceraColorHoja = '1C1B17';
    const tamanoContenido = 12;

    const rowHeader = worksheet.addRow(
        cabeceras
    );
    var borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
    };

    var borderStyleHeader = {
        left: { style: "thin", color: { argb: 'ffffff' } },
        right: { style: "thin", color: { argb: 'ffffff' } }
    };

    rowHeader.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: cabeceraColorHoja },
            bgColor: { argb: '' }
        };
        cell.font = {
            size: tamanoContenido,
            bold: true,
            color: { argb: 'ffffff' },
        };
        cell.alignment = {
            vertical: 'middle',
            horizontal: 'center'
        };
        cell.border = borderStyleHeader;
    });

    worksheet.columns = [
        { header: "", key: "FechaMaquina" },
        { header: "", key: "Transaccion" },
        { header: "", key: "Concepto" },
        { header: "", key: "Valor" },
        { header: "", key: "Saldo" },

    ];
    movements.forEach((value) => {
        worksheet.addRow(value).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = {
                name: fuenteHoja,
                size: tamanoContenido,
            };
            cell.border = borderStyle;
        })
    })

    const uint8Array = await workbook.xlsx.writeBuffer()

    const blob = new Blob([uint8Array], { type: "application/octet-binary" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Movimientos de Cuenta.xlsx`;
    a.click();
    a.remove();
}